import { render } from "./PostCard.vue?vue&type=template&id=1e50fd14&scoped=true"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"

import "./PostCard.vue?vue&type=style&index=0&id=1e50fd14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e50fd14"]])

export default __exports__